import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, LinearProgress } from "@mui/material";
import { ReactElement } from "react";
import { useGetHealthGeneralQuery } from "../../app/apislices/healthApi";

export default function GlobalDialog(): ReactElement {
  const result = useGetHealthGeneralQuery(undefined, {
    pollingInterval: 60000,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  return (
    <Dialog open={result.isLoading || typeof result.error === "object"}>
      {result.isLoading ? (
        <>
          <DialogTitle>Herzlich Willkommen bei Power Quality der TransnetBW</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Bitte warten Sie, während die Anwendung geladen wird.
              <br />
              <br />
              <LinearProgress variant="indeterminate" />
            </DialogContentText>
          </DialogContent>
        </>
      ) : (
        <>
          <DialogTitle>Herzlich Willkommen bei Power Quality der TransnetBW</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Leider konnte die Applikation nicht geladen werden.
              <br />
              Bitte prüfen Sie Ihre Verbindung zum TransnetBW-Intranet.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" variant="contained" onClick={() => window.history.go(0)}>
              Neuladen
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
